import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html'
})
export class LineChartComponent implements OnChanges {

  @Input() data: any[] = [];
  @Input() title = '';

  labels: string[] = [];
  values: number[] = [];

  ngOnChanges() {
    this.labels = this.data.map(d => d.date);
    this.values = this.data.map(d => d.bugs_created);
  }
}
